import axios from 'axios'

const apiIB = axios.create({
    baseURL: process.env.VUE_APP_IB_BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})

export default apiIB